const translations = {
    delete: 'Delete',
    edit: 'Edit',
    view: 'View'
};

export default translations;
